export const mockHouseStateCode = 'NORMAL';
